import React from 'react'
import ConstantsUtil from '../../context/constantsUtil'
import FormGroup from '../form-group'
import GeneralServices from '../../app/service/generalServices'
import * as popUp from '../../components/toastr'
import HandleErrorService from '../../app/service/handleErrorService'
import SelectMenu from '../selectMenu'
import { Dropdown } from 'primereact/dropdown'
import { InputNumber } from 'primereact/inputnumber'
import MonthCalendar from '../calendar/monthCalendar'
import CustomCalendar from '../calendar/customCalendar'

class ProvisaoReplicacaoComponent extends React.Component {

    constructor(){
        super()
    }

    state = {

        qtdMeses: '',
        inputQtdMesesErrorClass: '',

        tipoDataDePagamento: '',
        inputTipoDataPagamentoErrorClass: '',

        monthDate: '',
        monthDateView: '',
        inputMesInicialErrorClass: '',
        errorMesInicialMessage: '',

        diaDePagamento: '',
        inputDataPagamentoErroClass: '',
        errorDataPagamentoMessage: '',

        paymentDatesList: [],

    }

    handleChange = (event) => {
        const value = event.target.value
        const name = event.target.name
        this.setState({ [name]: value }, () => {
            if(['qtdMeses', 'tipoDataDePagamento', 'diaDePagamento'].includes(name)){
                this.recalcPaymentDates()
            }
        })
    }

    handleMonthDate = async (event) => {
        await this.handleUniqueMonthDateChange(event)
        // console.log("monthView: ", this.state.monthDateView)
        // console.log("monthDate: ", this.state.monthDate)
    }

    handleUniqueMonthDateChange = async (event) => {
        var value = event.value
        if(value !== null){
            value.setDate(1) //seta para o dia 1° do mês
        }

        var name = event.target.name

        await this.setState({ [name]: GeneralServices.convertJSDateToBrDate(value) })
        var nameView = name+"View"
        await this.setState({ [nameView]: value })
        this.recalcPaymentDates()
    }

    resetView = (setStates) => {
        if(setStates){
            this.setState({
                inputQtdMesesErrorClass: '',
    
                inputMesInicialErrorClass: '',
                errorMesInicialMessage: '',
    
                inputTipoDataPagamentoErrorClass: '',
    
                inputDataPagamentoErroClass: '',
                errorDataPagamentoMessage: '',
            })
        }
    }

    checkData = (setStates) => {

        this.resetView(setStates)

        let check = true

        if(!this.state.qtdMeses){
            if(setStates){
                this.setState({inputQtdMesesErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            }
            check = false
        }
        
        if(!this.state.monthDate){
            if(setStates){
                this.setState({
                    inputMesInicialErrorClass: ConstantsUtil.primereactInputErrorClass,
                    errorMesInicialMessage: 'Informe o mês inicial',

                })
            }
            check = false
        }

        if(!this.state.tipoDataDePagamento){
            if(setStates){
                this.setState({inputTipoDataPagamentoErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            }
            check = false
        }
        
        if(!this.state.diaDePagamento){
            if(setStates){
                this.setState({
                    inputDataPagamentoErroClass: ConstantsUtil.primereactInputErrorClass,
                    errorDataPagamentoMessage: 'Informe o dia'
                })
            }
            check = false
        }

        return check

    }

    getDatas = () => {

        let initialDateString = ''
        let finalDateString = ''

        // console.log("this.state: ", this.state)
        if(this.checkData(false)){

            let initialDate = new Date(this.state.monthDateView)
            const daysInInitialMonth = new Date(initialDate.getFullYear(), initialDate.getMonth() + 1, 0).getDate()
            initialDate.setDate(Math.min(this.state.diaDePagamento, daysInInitialMonth))
            let finalDate = new Date(initialDate.getTime())
            // console.log("this.state.qtdMeses: ", this.state.qtdMeses)
            finalDate.setMonth(finalDate.getMonth() + parseInt(this.state.qtdMeses) - 1)
            // finalDate.setMonth(finalDate.getMonth() + 3)

            initialDateString = GeneralServices.convertJSDateToBrDate(initialDate)
            finalDateString = GeneralServices.convertJSDateToBrDate(finalDate)

            if(this.state.tipoDataDePagamento === ConstantsUtil.tipoDataPagamentoDiaUtilDoMes){
                let trataDataFunction = (data) => {
                    return data.slice(3) + ` (${this.state.diaDePagamento}° dia útil)`
                }
                initialDateString = trataDataFunction(initialDateString)
                finalDateString = trataDataFunction(finalDateString)
            }
            initialDateString = initialDateString.replaceAll("-", "/")
            finalDateString = finalDateString.replaceAll("-", "/")
            // console.log("initialDate: ", GeneralServices.convertJSDateToBrDate(initialDate))
            // console.log("finalDate: ", GeneralServices.convertJSDateToBrDate(finalDate))

            return `Datas: ${initialDateString} a ${finalDateString}`
        }

        return ""

    }

    recalcPaymentDates = () => {
        if(!this.checkData(false)){
            this.setState({paymentDatesList: []})
            return
        }

        const qtdMeses = parseInt(this.state.qtdMeses)
        const currentList = this.state.paymentDatesList

        let newList = []
        for(let i = 0; i < qtdMeses; i++){
            let dataPagamento = new Date(this.state.monthDateView)
            dataPagamento.setMonth(dataPagamento.getMonth() + i)
            const daysInMonth = new Date(dataPagamento.getFullYear(), dataPagamento.getMonth() + 1, 0).getDate()
            dataPagamento.setDate(Math.min(parseInt(this.state.diaDePagamento), daysInMonth))

            let dataPagamentoDisplay = GeneralServices.convertJSDateToBrDate(dataPagamento)
            if(this.state.tipoDataDePagamento === ConstantsUtil.tipoDataPagamentoDiaUtilDoMes){
                dataPagamentoDisplay = dataPagamentoDisplay.slice(3) + ` (${this.state.diaDePagamento}° dia útil)`
            }
            dataPagamentoDisplay = dataPagamentoDisplay.replaceAll("-", "/")

            let dataLancamentoView = new Date(this.state.monthDateView)
            dataLancamentoView.setMonth(dataLancamentoView.getMonth() + i)
            dataLancamentoView.setDate(1)
            const dataLancamento = GeneralServices.convertJSDateToBrDate(dataLancamentoView)

            const valor = currentList[i] !== undefined ? currentList[i].valor : this.props.valorPagamento
            newList.push({ dataPagamentoDisplay, dataLancamento, dataLancamentoView, valor })
        }
        this.setState({paymentDatesList: newList})
    }

    handleValorPaymentChange = (event, index) => {
        const paymentDatesList = [...this.state.paymentDatesList]
        paymentDatesList[index] = { ...paymentDatesList[index], valor: event.value }
        this.setState({ paymentDatesList })
    }

    handleDataLancamentoChange = (event, index) => {
        const value = event.target.value
        const paymentDatesList = [...this.state.paymentDatesList]
        paymentDatesList[index] = {
            ...paymentDatesList[index],
            dataLancamento: GeneralServices.convertJSDateToBrDate(value),
            dataLancamentoView: value
        }
        this.setState({ paymentDatesList })
    }

    getResultObject = () => {
        let resultObject = {
            tipoDataDePagamento: this.state.tipoDataDePagamento,
            dataInicial: this.state.monthDate,
            diaDePagamento: this.state.diaDePagamento,
            qtdMeses: this.state.qtdMeses,
            paymentDatesList: this.state.paymentDatesList
        }
        return resultObject
    }

    reset = () => {
        this.setState({
            qtdMeses: '',
            tipoDataDePagamento: '',
            monthDate: '',
            diaDePagamento: '',
            paymentDatesList: [],
        })
    }

    render(){

        const renderDiaDoMes = () => {
            if(this.state.tipoDataDePagamento){
                return (
                    <div className = {`col-md-4`}>
                        <label style={{ display: 'block' }}>Dia do Pagamento</label>
                        <Dropdown
                            className={this.state.inputDataPagamentoErroClass}
                            name="diaDePagamento"
                            value={this.state.diaDePagamento}
                            options={
                                this.state.tipoDataDePagamento === ConstantsUtil.tipoDataPagamentoDiaFixoDoMes ?
                                    ConstantsUtil.getDiasDoMesList()
                                    : ConstantsUtil.getDiasUteisDoMesList()
                            }
                            onChange={this.handleChange}
                            optionLabel="label"
                            filter
                            showClear
                            filterBy="label"
                            placeholder="Selecione"
                            emptyMessage=""
                            emptyFilterMessage=""
                        />
                        <small className="p-error">{this.state.errorDataPagamentoMessage}</small>                        
                    </div>
                )
            }
        }

        const renderPaymentDatesList = () => {
            const { paymentDatesList } = this.state
            if(!paymentDatesList || paymentDatesList.length === 0) return null

            return (
                <>
                    {paymentDatesList.map((item, index) => (
                        <div className='row' key={index}>
                            <div className='col-md-3'>
                                <CustomCalendar
                                    label={`Data de Lançamento/Competência ${index + 1}`}
                                    noHTMLFormat
                                    value={item.dataLancamentoView}
                                    onChange={(event) => this.handleDataLancamentoChange(event, index)}
                                />
                            </div>
                            <div className='col-md-3'>
                                <FormGroup label={`Data de Pagamento ${index + 1}`}>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={item.dataPagamentoDisplay}
                                        disabled
                                        readOnly
                                    />
                                </FormGroup>
                            </div>
                            <div className='col-md-3'>
                                <label style={{ display: 'block' }}>{`Valor ${index + 1}`}</label>
                                <InputNumber
                                    mode="decimal" locale="pt-BR" minFractionDigits={2}
                                    value={item.valor}
                                    onValueChange={(event) => this.handleValorPaymentChange(event, index)}
                                />
                            </div>
                        </div>
                    ))}
                </>
            )
        }

        const renderComponent = () => {
            if(this.props.valorPagamento)
            return (
                <>
                    <div className='row'>

                        <div className = {`col-md-3`}>
                            <FormGroup label = "Quantidade de meses a replicar">
                                <input
                                    type="number"
                                    id="inputQtdMeses"
                                    className={"form-control " + this.state.inputQtdMesesErrorClass}
                                    name="qtdMeses"
                                    value = {this.state.qtdMeses}
                                    onChange={this.handleChange}
                                    placeholder="Digite a quantidade de meses a replicar"
                                    disabled={this.props.disabled || GeneralServices.isTelaPreValidacaoNFs()}
                                />
                                {/* <div className="invalid-feedback">{this.state.errorParcelasMessage}</div> */}
                                <div className="invalid-feedback">Selecione a quantidade de meses</div>
                            </FormGroup>
                        </div>

                        <MonthCalendar
                            ref={this.monthDateRef}
                            label="Mês de Início"
                            id="monthpicker"
                            name="monthDate"
                            value={this.state.monthDate}
                            onChange={this.handleMonthDate}
                            htmlFor="dataLancamentoFim"
                            disabled={this.props.disabled}
                            inputDateErrorClass={this.state.inputMesInicialErrorClass}
                            errorDateMessage={this.state.errorMesInicialMessage}
                        />

                        <div className = {`col-md-3`}>
                            <FormGroup label = "Tipo de Data de Pagamento">
                                <SelectMenu
                                    className={"form-control " + this.state.inputTipoDataPagamentoErrorClass}
                                    name="tipoDataDePagamento"
                                    list={ConstantsUtil.tipoDataPagamentoProvisaoRecorrente}
                                    value={this.state.tipoDataDePagamento}
                                    onChange={this.handleChange}
                                    disabled={this.props.disabled || this.state.disableTipoDeCorte}
                                />
                                {/* <div className="invalid-feedback">{this.state.errorTipoCorteMessage}</div>   */}
                                <div className="invalid-feedback">Informe o tipo de data de pagamento</div>
                            </FormGroup>
                        </div>

                        {renderDiaDoMes()}

                    </div>

                    {renderPaymentDatesList()}

                </>
            )
        }

        return(
            <>
            {renderComponent()}
            </>
        )


    }

}

export default ProvisaoReplicacaoComponent